import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import PhysicianPagesAdminPanel from '@medflex/components/stories/PhysicianPagesAdminPanel';
import Spinner from '@medflex/components/stories/Spinner';
import { showAlertToast, showSuccessToast } from '@medflex/components/stories/Toast';
import Logger from '@medflex/utils/Logger';

import ErrorPage from '../../components/ErrorPage';
import { MODALS } from '../../hooks/useIsModal';
import useModal from '../../hooks/useModal';
import useUserProfile from '../../hooks/useUserProfile';

// eslint-disable-next-line import/no-unresolved
const RemoteWidgetSettings = React.lazy(() => import('RemoteWidget/SettingsAdvanced'));

const WidgetSettingsModal = () => {
  const { t } = useTranslation('physician');
  const { userProfile, editContactPage } = useUserProfile();
  const { close } = useModal();

  const closeModal = () => {
    close({ modal: MODALS.physicianPagesWidgetSettings });
  };

  const handleSubmit = async (event, newSettings) => {
    event.preventDefault();

    try {
      await editContactPage({
        widgetSettings: newSettings,
      });
      closeModal();
      showSuccessToast(t('toasts.contact_page.success.title'), null, {
        toastId: 'widgetSettingsSuccess',
      });
    } catch (e) {
      Logger.error(e);
      showAlertToast(t('PhysicianPersonalProfileEditModule.unexpected_error.title'), null, {
        toastId: 'widgetSettingsFailed',
      });
    }
  };

  return (
    <PhysicianPagesAdminPanel onClose={closeModal}>
      {userProfile?.attributes?.pages?.widgetSettings && (
        <Suspense
          fallback={
            <div className="flex w-full items-center justify-center">
              <Spinner size="3xl" />
            </div>
          }
        >
          <ErrorPage className="h-auto w-full" userType={userProfile?.type}>
            <RemoteWidgetSettings
              onSubmit={handleSubmit}
              settings={userProfile.attributes.pages.widgetSettings || null}
              className="max-h-full overflow-y-hidden flex w-full"
            />
          </ErrorPage>
        </Suspense>
      )}
    </PhysicianPagesAdminPanel>
  );
};

export default WidgetSettingsModal;
